import { NavigationManagerActionTypes } from 'src/store/actions/navigationManager.actions';
import { NavigationManagerStateModel } from 'src/store/initial.state';

const NavigationManagerReducer = (state = new NavigationManagerStateModel(), { type, payload }) => {
  switch (type) {
    case NavigationManagerActionTypes.GET_NAVIGATION_TREE_SUCCESS:
      return {
        ...state,
        navigationTree: payload.data,
      };

    case NavigationManagerActionTypes.SAVE_NAVIGATION_TREE_SUCCESS:
      return {
        ...state,
        savedNavigationMenu: payload.data,
      };

    default:
      return state;
  }
};

export { NavigationManagerReducer };
